import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MeasuresFacade } from '@library/store/measures/measures.facade';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { ControlPageStore, GraphDataset, GraphType } from '@pages/control-page/control-page-store.service';
import { combineLatest, map, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-control-page-graph-legend',
  templateUrl: './control-page-graph-legend.component.html',
  styleUrls: ['./control-page-graph-legend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlPageGraphLegendComponent {

  GraphType = GraphType;

  private datasets$ = this.controlPageStore.datasets$.pipe(
    map(d => ([...d]))
  );

  private totals$ = combineLatest([this.datasets$, this.controlPageStore.scale$, this.controlPageStore.timeRange$]).pipe(
    switchMap(([datasets, scale, timeRange]) => {
      return combineLatest(datasets.map(d => {
        if (d.home) {
          return this.measuresFacade.getTimeRangeMeasuresTotal(
            d.home.id,
            [d.measureType],
            this.controlPageStore.scaleToApiScale(scale),
            timeRange,
          );
        }
        else if (d.module) {
          return this.measuresFacade.getModuleTotal(
            d.module.id,
            d.measureType,
            this.controlPageStore.scaleToApiScale(scale),
            timeRange,
          );
        }
        else {
          return of(0);
        }
      }));
    })
  );

  vm$ = combineLatest({
    card: this.controlPageStore.card$,
    datasets: this.controlPageStore.datasets$,
    scale: this.controlPageStore.scale$,
    totals: this.totals$,
    graphMode: this.controlPageStore.options$.pipe(map(o => o.graphMode)),
  });

  constructor(
    private controlPageStore: ControlPageStore,
    private measuresFacade: MeasuresFacade,
  ) { }

  showLabel(dataset: GraphDataset) {
    switch (dataset.measureType) {
      case EnumMeasureTypes.WIND_ANGLE:
        return false;
      default:
        return true;
    }
  }

  showTotals(graphType: GraphType) {
    return [GraphType.ELEC, GraphType.ELEC_PEAK_OFFPEAK, GraphType.WATER].includes(graphType);
  }

  toggleDatasetVisibility(datasetIndex: number, length: number) {
    if (length > 1) {
      this.controlPageStore.toggleDatasetVisibility({datasetIndex});
    }
  }

}
